import React from 'react';

const provincias = (props) => {
  return (<>
    <div>
      <label>Provincias:</label>
      <select onChange={props.handleChange}>
        <option value="">Seleccione una provincia</option>
        {props.opciones.map((opcion) => (
          <option key={opcion} value={opcion}>
            {opcion}
          </option>
        ))}
      </select>
    </div>
    </>
  );
};

export default provincias;
